import { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { Inject } from 'inversify-props'
import type { ImportacaoDeNotaServiceAdapter } from './adapter'

export class ImportarNotaDoFornecedorUseCase {
	@Inject('ImportacaoDeNotaServiceAdapter')
	private importacaoDeNotaServiceAdapter!: ImportacaoDeNotaServiceAdapter

	async execute(
		arquivo: File | null,
	): Promise<ImportacaoDeNota> {
		if (!arquivo) throw new Error('Arquivo não informado')

		const importacaoDeNota = await this.importacaoDeNotaServiceAdapter.importar(arquivo)
		
		return {
			...importacaoDeNota,
		}
	}

	async buscarItensDeImportacao(usuario: string): Promise<ImportacaoDeNota[]> {
		return this.importacaoDeNotaServiceAdapter.buscarItensDeImportacao(usuario);
	}

	async buscarImportacaoDeNota(chNfe: string, config?: any): Promise<ImportacaoDeNota> {
		return this.importacaoDeNotaServiceAdapter.buscarImportacaoDeNota(chNfe, config);
	}

	async delete(id: string): Promise<void> {
		return this.importacaoDeNotaServiceAdapter.delete(id);
	}
}
